// @ts-ignore
import * as uuid from "uuid";
import useAlertStore from "../store/AlertStore";
import type {RpcError} from "grpc-web";

import {EudUserAccountServiceClient} from "@ev24/proto-eud-luna-web-api/elwa_v1_grpc_web_pb";

import type {
    EudTokenResponse,
    EudLiteResponse,
    EudTokenRefreshResponse,
    E24UserAccountSignUpResponse,
} from "@ev24/proto-eud-luna-web-api/elwa_v1_pb";

import type {GRPCHeaders, GRPCOptions} from "../interfaces/AuthInterface";
import type * as jspb from "google-protobuf";
import type {Resolve, Reject} from "../utility/InterfacePromise";
import type * as elwa_v1_pb from "@ev24/proto-eud-luna-web-api/elwa_v1_pb";

export type GRPCHandler = (response: jspb.Message | null, err: RpcError | null, resolve: Resolve, reject: Reject) => void;

export default class GRPCLuna {

    protected readonly _path: any;
    protected readonly _options: GRPCOptions;
    protected readonly _headers: GRPCHeaders;

    constructor(path: string, headers: GRPCHeaders = {}, options: GRPCOptions = {}) {
        this._path = path;
        this._options = options;
        this._headers = headers;
    }


    getUuid() {
        return uuid.v4();
    }


    userAccountClient(): EudUserAccountServiceClient {
        return new EudUserAccountServiceClient(this._path, this._options);
    }

    protected genericHandler(successMessage: string, response: elwa_v1_pb.EudLiteResponse, err: RpcError, resolve: Resolve, reject: Reject) {
        let responseData = null;
        const alertStore = useAlertStore();
        try {
           responseData = this.responseData(response);
        } catch (e) {
            alertStore.error("500: Server error LS101");
            console.error({err}, {responseData});
            reject(err);
            return;
        }

        if (responseData === null) {
            reject(err);
            return;
        }

        if (parseInt(responseData.code) === 200) {
          alertStore.success(successMessage);
          resolve(responseData);
        } else if (parseInt(responseData.code) === 422) {
          alertStore.error(responseData.message);
          reject(responseData);
        } else {
          alertStore.error("An unknown error occurred: SUP1002");
          reject(err);
        }
    }

    responseData(
        response: EudTokenRefreshResponse
    ): EudTokenRefreshResponse.AsObject | null;
    responseData(
        response: EudTokenResponse
    ): EudTokenResponse.AsObject | null;
    responseData(
        response: E24UserAccountSignUpResponse
    ): E24UserAccountSignUpResponse.AsObject | null;
    responseData(
        response: EudLiteResponse
    ): EudLiteResponse.AsObject | null;
    responseData(
        response: EudLiteResponse | EudTokenResponse | EudTokenRefreshResponse
    ) {
        try {
            if (response) {
                return response.toObject();
            }
        } catch (e) {
            const alertStore = useAlertStore();
            alertStore.error("500: Server error SL101");
        }
        return null;
    }
}
